import React from 'react';

interface IHintIconSuccessProps {
	size?: string;
	fill?: string;
	className?: string;
}

export const HintIconSuccess = ({
	size = '24',
	className = '',
	fill = '#0079C0',
}: IHintIconSuccessProps) => (
	<svg
		role="img"
		className={className}
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-labelledby="hintIconSuccess">
		<g clip-path="url(#clip0_60_141)">
			<path
				d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
				fill={fill}
			/>
		</g>
		<defs>
			<clipPath id="clip0_60_141">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
